import React from 'react';
import ReactDOM from 'react-dom/client';
import './iss-tokens.css';
import './index.css';
import './theme/index.scss';
import AppRouter from './AppRouter';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './config/MsalConfig';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <MsalProvider instance={msalInstance}>
      <AppRouter />
    </MsalProvider>
  );
}
